// 雨见浏览器「小雨」语音会话的接入点。aihelp 被多个项目共用,语音功能只在宿主同时满足两个标记时启用:
//   1. 网址带 voice=1(雨见浏览器开启语音待命后才加)
//   2. 宿主注入了 window.rainseeBrowser.voice,且协议版本是 rainsee-voice/1
// 只有其中一个(例如别的项目手动加了 voice=1)一律不启用,也不会下载语音界面代码。
// 协议见 rainsee-pc md/ai-voice-protocol.md。

export const VOICE_PROTOCOL = 'rainsee-voice/1';
export const VOICE_ENTRY_ACTION = 'open-voice';

const hasVoiceFlag = () => {
  if (typeof window === 'undefined') return false;
  try {
    return new URLSearchParams(window.location.search).get('voice') === '1';
  } catch (e) {
    return false;
  }
};

export const getVoiceBridge = () => {
  if (!hasVoiceFlag()) return null;
  const bridge = window.rainseeBrowser && window.rainseeBrowser.voice;
  if (!bridge || bridge.voiceProtocol !== VOICE_PROTOCOL) return null;
  if (typeof bridge.getSession !== 'function' || typeof bridge.sendText !== 'function') return null;
  return bridge;
};

export const isVoiceSessionAvailable = () => !!getVoiceBridge();

// 订阅宿主推送:轮次更新与语音状态。返回取消订阅函数。
// onHeard:听到但没回答的一句话(老版本浏览器不推)
export const subscribeVoice = ({ onTurn, onState, onHeard }) => {
  const turnHandler = (e) => onTurn && e && e.detail && onTurn(e.detail);
  const stateHandler = (e) => onState && e && e.detail && onState(e.detail);
  const heardHandler = (e) => onHeard && e && e.detail && onHeard(e.detail);
  window.addEventListener('rainsee-voice-turn', turnHandler);
  window.addEventListener('rainsee-voice-state', stateHandler);
  window.addEventListener('rainsee-voice-heard', heardHandler);
  return () => {
    window.removeEventListener('rainsee-voice-turn', turnHandler);
    window.removeEventListener('rainsee-voice-state', stateHandler);
    window.removeEventListener('rainsee-voice-heard', heardHandler);
  };
};
